/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllSystemFormsApiV2SystemFormsOrgAllGet } from '../fn/system-forms-v-2/get-all-system-forms-api-v-2-system-forms-org-all-get';
import { GetAllSystemFormsApiV2SystemFormsOrgAllGet$Params } from '../fn/system-forms-v-2/get-all-system-forms-api-v-2-system-forms-org-all-get';
import { PageSystemForms } from '../models/page-system-forms';
import { readSystemFormsApiV2SystemFormsOrgFormIdGet } from '../fn/system-forms-v-2/read-system-forms-api-v-2-system-forms-org-form-id-get';
import { ReadSystemFormsApiV2SystemFormsOrgFormIdGet$Params } from '../fn/system-forms-v-2/read-system-forms-api-v-2-system-forms-org-form-id-get';
import { SystemFormsWithVersions } from '../models/system-forms-with-versions';

@Injectable({ providedIn: 'root' })
export class SystemFormsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllSystemFormsApiV2SystemFormsOrgAllGet()` */
  static readonly GetAllSystemFormsApiV2SystemFormsOrgAllGetPath = '/api/v2/system-forms/{org}/all';

  /**
   * Get All System Forms.
   *
   * Retrieve all system form records.
   *
   * This endpoint retrieves all system form records from the database with linked data,
   * and returns them in a paginated format.
   *
   * Args:
   *     org (Any): The organization details obtained via dependency injection.
   *
   * Returns:
   *     Page[schemas.SystemForms]: A paginated list of system form records.
   *
   * Raises:
   *     HTTPException: If user validation fails or if any error occurs during data retrieval.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSystemFormsApiV2SystemFormsOrgAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSystemFormsApiV2SystemFormsOrgAllGet$Response(params: GetAllSystemFormsApiV2SystemFormsOrgAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSystemForms>> {
    return getAllSystemFormsApiV2SystemFormsOrgAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All System Forms.
   *
   * Retrieve all system form records.
   *
   * This endpoint retrieves all system form records from the database with linked data,
   * and returns them in a paginated format.
   *
   * Args:
   *     org (Any): The organization details obtained via dependency injection.
   *
   * Returns:
   *     Page[schemas.SystemForms]: A paginated list of system form records.
   *
   * Raises:
   *     HTTPException: If user validation fails or if any error occurs during data retrieval.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSystemFormsApiV2SystemFormsOrgAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSystemFormsApiV2SystemFormsOrgAllGet(params: GetAllSystemFormsApiV2SystemFormsOrgAllGet$Params, context?: HttpContext): Observable<PageSystemForms> {
    return this.getAllSystemFormsApiV2SystemFormsOrgAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSystemForms>): PageSystemForms => r.body)
    );
  }

  /** Path part for operation `readSystemFormsApiV2SystemFormsOrgFormIdGet()` */
  static readonly ReadSystemFormsApiV2SystemFormsOrgFormIdGetPath = '/api/v2/system-forms/{org}/{formId}';

  /**
   * Read System Forms.
   *
   * Retrieve a system form document by formId with version information.
   *
   * This endpoint retrieves a system form record using the provided formId. If a versionId is specified,
   * it retrieves the corresponding system form version; otherwise, it returns the default version.
   * Additionally, the endpoint fetches the associated form data for the selected version and embeds it
   * within the returned document.
   *
   * Args:
   *     auth_token (Any): The authentication token with user details.
   *     org (Any): The organization details obtained via dependency injection.
   *     formId (str): The unique identifier of the system form to retrieve.
   *     versionId (PydanticObjectId, optional): The identifier of a specific form version. Defaults to None.
   *
   * Returns:
   *     Union[schemas.SystemFormsWithVersions, dict]: The system form document including version details
   *     and form data, or an empty dictionary if not found.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the specified versionId is not found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readSystemFormsApiV2SystemFormsOrgFormIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  readSystemFormsApiV2SystemFormsOrgFormIdGet$Response(params: ReadSystemFormsApiV2SystemFormsOrgFormIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<(SystemFormsWithVersions | {
})>> {
    return readSystemFormsApiV2SystemFormsOrgFormIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Read System Forms.
   *
   * Retrieve a system form document by formId with version information.
   *
   * This endpoint retrieves a system form record using the provided formId. If a versionId is specified,
   * it retrieves the corresponding system form version; otherwise, it returns the default version.
   * Additionally, the endpoint fetches the associated form data for the selected version and embeds it
   * within the returned document.
   *
   * Args:
   *     auth_token (Any): The authentication token with user details.
   *     org (Any): The organization details obtained via dependency injection.
   *     formId (str): The unique identifier of the system form to retrieve.
   *     versionId (PydanticObjectId, optional): The identifier of a specific form version. Defaults to None.
   *
   * Returns:
   *     Union[schemas.SystemFormsWithVersions, dict]: The system form document including version details
   *     and form data, or an empty dictionary if not found.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the specified versionId is not found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readSystemFormsApiV2SystemFormsOrgFormIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readSystemFormsApiV2SystemFormsOrgFormIdGet(params: ReadSystemFormsApiV2SystemFormsOrgFormIdGet$Params, context?: HttpContext): Observable<(SystemFormsWithVersions | {
})> {
    return this.readSystemFormsApiV2SystemFormsOrgFormIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<(SystemFormsWithVersions | {
})>): (SystemFormsWithVersions | {
}) => r.body)
    );
  }

}
